import React, { ReactNode } from "react";
import { Box, FormHelperText, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PromiseStatus } from "../../../core/PromiseStatus";
import { LoadingButton } from "@mui/lab";
import SubmitButton from "./SubmitButton";

const FormButtons: React.FC<FormButtonsProps> = (props) => {
    const styles = useStyles(props.noSticky)();

    const pending = !!props.formStatus?.pending();

    return (
        <Box className={ styles.root }>
            <Grid container justifyContent='flex-end' alignItems='center'>
                <Box mr={ 4 }>
                    {
                        props.formHasErrors && !pending &&
                        <FormHelperText error>
                            { props.errorText || 'Formularz zawiera błędy' }
                        </FormHelperText>
                    }
                </Box>

                <Box mt={ 1 }>
                    <Grid container spacing={ 2 } flexDirection='row'>
                        {
                            !props.buttons &&
                            <SubmitButton
                                isLoading={ pending }
                                disabled={ props.disabled }
                                text={ props.okText }
                            />
                        }
                        {
                            props.buttons?.map(button => (
                                <Grid key={ button.text } item>
                                    <LoadingButton
                                        loadingPosition='center'
                                        loading={ pending }
                                        type={ button.type || 'submit' }
                                        className={ button.variant === 'other' ? styles.otherBtn : styles.submitBtn }
                                        disabled={ pending || props.disabled || button.disabled }
                                        onClick={ button.onClick }
                                        variant={ button.variant === 'other' ? 'outlined' : 'text' }
                                    >
                                        &nbsp;{ !pending && button.text }&nbsp;
                                    </LoadingButton>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Box>
            </Grid>
        </Box>
    );
}


interface FormButtonsProps {
    readonly formIsDirty: boolean;
    readonly formStatus: PromiseStatus | undefined;
    readonly formHasErrors: boolean;
    readonly disabled?: boolean;
    readonly okText?: string;
    readonly errorText?: string|ReactNode;
    readonly buttons?: Array<FormButtonProps>;
    readonly noSticky?: boolean
}

export interface FormButtonProps {
    readonly text: string;
    readonly onClick: () => void;
    readonly variant?: 'submit' | 'other';
    readonly type?: 'submit' | 'button' | 'reset';
    readonly disabled?: boolean;
}

const useStyles = (noSticky?: boolean) => makeStyles(theme => ({
    root: {
        position: noSticky ? 'static' : 'sticky',
        bottom: 0,
        marginTop: theme.spacing(noSticky ? 0 : 2),
        paddingTop: theme.spacing(noSticky ? 0 : 2),
        paddingBottom: theme.spacing(noSticky ? 0 : 2),
        zIndex: 501,
        width: 'fit-content',
        marginLeft: 'auto'
    },
    submitBtn: {
        minWidth: '110px !important',
        backgroundColor: theme.palette.secondary.main + ' !important',
        color: theme.palette.secondary.contrastText + ' !important',
        '&:disabled': {
            backgroundColor: theme.palette.secondary.dark + ' !important',
        }
    },
    otherBtn: {
        minWidth: '110px !important',
        color: theme.palette.secondary.main + ' !important',
        borderColor: theme.palette.secondary.main + ' !important',
    }
}))


export default FormButtons;
